<template>
    <section class="container relative">
        <div
            ref="slider-container"
            class="swiper container">
            <div class="swiper-wrapper grid-cols-2 lg:!grid lg:gap-5">
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="swiper-slide !h-auto">
                    <ThesisCard
                        :item="item"
                        :active="activeSlide === index" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'
import { Swiper } from 'swiper'
import 'swiper/css'
import { MAX_MOBILE_WIDTH } from '~/const/config'

import ThesisCard from '~/components/base/thesis-card/ThesisCard.vue'
import type { IThesesSectionItem } from '~/components/particles/theses-section/theses-section.types'

defineProps({
    items: {
        type: Array as PropType<IThesesSectionItem[]>,
        default: () => [],
    },
})

const { width } = useWindowSize()

const sliderRef = useTemplateRef('slider-container')
let slider: Swiper | null = null
const activeSlide = ref<number | null>(null)

const initSlider = () => {
    if (!sliderRef.value || slider) return

    slider = new Swiper(sliderRef.value, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        on: {
            slideChange: (_swiper: Swiper): void => {
                activeSlide.value = _swiper.activeIndex
            },
        },
    })

    activeSlide.value = slider.activeIndex
}

const destroySlider = () => {
    if (!slider) return

    slider.destroy()
    slider = null
}

const checkSlider = () => {
    if (width.value >= MAX_MOBILE_WIDTH) {
        destroySlider()
        return
    }
    initSlider()
}

watch(width, checkSlider)

onMounted(checkSlider)
</script>
